import Vue from 'vue';
export const EventBus = new Vue();

export enum Key {
  ChangeFeedTab = 'changeFeedTab',
  DeleteRace = 'deleteRace',
  ShowTrainingPlanItem = 'showTrainingPlanItem',
  ShowImportedActivity = 'showImportedActivity',
};
